<div class="history-tabs-sec">
    <elastic-tabs
        [input]="activeHistoryTab"
        [tabsconfig]="historyTabsConfig"
        [inputclass]="
            'perf-tabs nav nav-tabs history-tabs justify-content-start'
        "
    >
    </elastic-tabs>

    <div class="history-tab-sec-2">
        <div class="show-num-records">
            <div class="row nogutter">
                <div class="col text-right">
                    {{ i18n._7356___OF_RECORDS_DISPLAYED | translate }}:
                    <a
                        [class.active]="displayRecords == 10"
                        (click)="showRecords(10)"
                        >10</a
                    >
                    <a
                        [class.active]="displayRecords == 25"
                        (click)="showRecords(25)"
                        >25</a
                    >
                    <a
                        [class.active]="displayRecords == numRecords"
                        (click)="showRecords(numRecords)"
                        >{{ i18n._109_ALL | translate }}</a
                    >
                </div>
            </div>
            <div class="row nogutter">
                <div class="col text-right">
                    {{ i18n._7357_SHOWING | translate }} {{ displayedRecords }}
                    {{ i18n._7358_OF | translate }} {{ totalRecords }}
                    {{ i18n._7359_TOTAL_RECORDS | translate }}
                </div>
            </div>
        </div>

        <button
            class="btn filter-button"
            type="button"
            [class.active]="showHistoryFilter"
            (click)="toggleHistoryFilter()"
        >
            <cmps-icon svgIcon="tune-variant"></cmps-icon>
            <span class="ng-tns-c6-5">{{ i18n._7360_FILTER | translate }}</span>
        </button>
    </div>
</div>

<div
    class="coaching-history-filter-options"
    *ngIf="showHistoryFilter == true"
>
    <div
        class="coaching-history-filters"
        *ngIf="activeHistoryTab == 'tab-observations'"
    >
        <div class="row p-2">
            <div class="col p-1">
                <label class="mb-0">{{
                    i18n._7309_SESSION_TYPE | translate
                }}</label>
                <ng-select
                    [placeholder]="placeholderText"
                    [notFoundMsg]="i18n._7413_NO_RESULTS_FOUND | translate"
                    [options]="ObservationFilterOptions.SessionTypes"
                    [ngModel]="
                        ObservationFilter.sessionTypeId == null
                            ? null
                            : ObservationFilter.sessionTypeId
                    "
                    (ngModelChange)="
                        ObservationFilter.sessionTypeId =
                            $event === '' ? null : $event
                    "
                    forceDropdownPosition
                >
                </ng-select>
            </div>
            <div class="col p-1">
                <label class="mb-0">{{
                    i18n._7347_OBSERVER | translate
                }}</label>
                <ng-select
                    [placeholder]="placeholderText"
                    [notFoundMsg]="i18n._7413_NO_RESULTS_FOUND | translate"
                    [options]="ObservationFilterOptions.Observers"
                    [ngModel]="
                        ObservationFilter.observerId == null
                            ? null
                            : ObservationFilter.observerId
                    "
                    (ngModelChange)="
                        ObservationFilter.observerId =
                            $event === '' ? null : $event
                    "
                    forceDropdownPosition
                >
                </ng-select>
            </div>
            <div class="col p-1">
                <label class="mb-0">{{ i18n._127_STATUS | translate }}</label>
                <ng-select
                    [placeholder]="placeholderText"
                    [notFoundMsg]="i18n._7413_NO_RESULTS_FOUND | translate"
                    [options]="ObservationFilterOptions.Statuses"
                    [ngModel]="
                        ObservationFilter.statusId == null
                            ? null
                            : ObservationFilter.statusId
                    "
                    (ngModelChange)="
                        ObservationFilter.statusId =
                            $event === '' ? null : $event
                    "
                    forceDropdownPosition
                >
                </ng-select>
            </div>
            <div class="col p-1">
                <label class="mb-0">{{ i18n._7361_FOCUS | translate }}</label>
                <ng-select
                    [placeholder]="placeholderText"
                    [notFoundMsg]="i18n._7413_NO_RESULTS_FOUND | translate"
                    [options]="ObservationFilterOptions.Focuses"
                    [ngModel]="
                        ObservationFilter.focusId == null
                            ? null
                            : ObservationFilter.focusId
                    "
                    (ngModelChange)="
                        ObservationFilter.focusId =
                            $event === '' ? null : $event
                    "
                    forceDropdownPosition
                >
                </ng-select>
            </div>
            <div class="col p-1 pt-3 history-filter-buttonset">
                <button
                    class="btn mr-2"
                    (click)="filter('OBSERVATIONS')"
                >
                    {{ i18n._7362_APPLY | translate }}
                </button>
                <button
                    class="btn"
                    (click)="clearFilter('OBSERVATIONS')"
                >
                    {{ i18n._7363_CLEAR | translate }}
                </button>
            </div>
        </div>
    </div>

    <div
        class="coaching-history-filters"
        *ngIf="activeHistoryTab == 'tab-commitments'"
    >
        <div class="row p-2">
            <div class="col p-1">
                <label class="mb-0">{{
                    i18n._7334_BEHAVIOUR | translate
                }}</label>
                <ng-select
                    [placeholder]="placeholderText"
                    [notFoundMsg]="i18n._7413_NO_RESULTS_FOUND | translate"
                    [options]="CommitmentFilterOptions.Behaviours"
                    [ngModel]="
                        CommitmentFilter.behaviour == null
                            ? null
                            : CommitmentFilter.behaviour
                    "
                    (ngModelChange)="
                        CommitmentFilter.behaviour =
                            $event === '' ? null : $event
                    "
                    forceDropdownPosition
                >
                </ng-select>
            </div>
            <div class="col p-1">
                <label class="mb-0">{{
                    i18n._7364_SUB_BEHAVIOUR | translate
                }}</label>
                <ng-select
                    [placeholder]="placeholderText"
                    [notFoundMsg]="i18n._7413_NO_RESULTS_FOUND | translate"
                    [options]="CommitmentFilterOptions.SubBehaviours"
                    [ngModel]="
                        CommitmentFilter.subBehaviour == null
                            ? null
                            : CommitmentFilter.subBehaviour
                    "
                    (ngModelChange)="
                        CommitmentFilter.subBehaviour =
                            $event === '' ? null : $event
                    "
                    forceDropdownPosition
                >
                </ng-select>
            </div>
            <div class="col p-1">
                <label class="mb-0">{{ i18n._7308_COACH | translate }}</label>
                <ng-select
                    [placeholder]="placeholderText"
                    [notFoundMsg]="i18n._7413_NO_RESULTS_FOUND | translate"
                    [options]="CommitmentFilterOptions.Coaches"
                    [ngModel]="
                        CommitmentFilter.coachId == null
                            ? null
                            : CommitmentFilter.coachId
                    "
                    (ngModelChange)="
                        CommitmentFilter.coachId = $event === '' ? null : $event
                    "
                    forceDropdownPosition
                >
                </ng-select>
            </div>
            <div class="col p-1">
                <label class="mb-0">{{
                    i18n._7309_SESSION_TYPE | translate
                }}</label>
                <ng-select
                    [placeholder]="placeholderText"
                    [notFoundMsg]="i18n._7413_NO_RESULTS_FOUND | translate"
                    [options]="CommitmentFilterOptions.SessionTypes"
                    [ngModel]="
                        CommitmentFilter.sessionTypeId == null
                            ? null
                            : CommitmentFilter.sessionTypeId
                    "
                    (ngModelChange)="
                        CommitmentFilter.sessionTypeId =
                            $event === '' ? null : $event
                    "
                    forceDropdownPosition
                >
                </ng-select>
            </div>
            <div class="col p-1">
                <label class="mb-0">{{ i18n._127_STATUS | translate }}</label>
                <ng-select
                    [placeholder]="placeholderText"
                    [notFoundMsg]="i18n._7413_NO_RESULTS_FOUND | translate"
                    [options]="CommitmentFilterOptions.Statuses"
                    [ngModel]="
                        CommitmentFilter.statusId == null
                            ? null
                            : CommitmentFilter.statusId
                    "
                    (ngModelChange)="
                        CommitmentFilter.statusId =
                            $event === '' ? null : $event
                    "
                    forceDropdownPosition
                >
                </ng-select>
            </div>
            <div class="col p-1 pt-3 history-filter-buttonset">
                <button
                    class="btn mr-2"
                    (click)="filter('COMMITMENTS')"
                >
                    {{ i18n._7362_APPLY | translate }}
                </button>
                <button
                    class="btn"
                    (click)="clearFilter('COMMITMENTS')"
                >
                    {{ i18n._7363_CLEAR | translate }}
                </button>
            </div>
        </div>
    </div>

    <div
        class="coaching-history-filters"
        *ngIf="activeHistoryTab == 'tab-goals'"
    >
        <div class="row p-2">
            <div class="col p-1">
                <label class="mb-0">{{ i18n._713_METRIC | translate }}</label>
                <ng-select
                    [placeholder]="placeholderText"
                    [notFoundMsg]="i18n._7413_NO_RESULTS_FOUND | translate"
                    [options]="GoalFilterOptions.Metrics"
                    [ngModel]="
                        GoalFilter.metricId == null ? null : GoalFilter.metricId
                    "
                    (ngModelChange)="
                        GoalFilter.metricId = $event === '' ? null : $event
                    "
                    forceDropdownPosition
                >
                </ng-select>
            </div>
            <div class="col p-1">
                <label class="mb-0">{{ i18n._7308_COACH | translate }}</label>
                <ng-select
                    [placeholder]="placeholderText"
                    [notFoundMsg]="i18n._7413_NO_RESULTS_FOUND | translate"
                    [options]="GoalFilterOptions.Coaches"
                    [ngModel]="
                        GoalFilter.coachId == null ? null : GoalFilter.coachId
                    "
                    (ngModelChange)="
                        GoalFilter.coachId = $event === '' ? null : $event
                    "
                    forceDropdownPosition
                >
                </ng-select>
            </div>
            <div class="col p-1">
                <label class="mb-0">{{ i18n._7365_CREATOR | translate }}</label>
                <ng-select
                    [placeholder]="placeholderText"
                    [notFoundMsg]="i18n._7413_NO_RESULTS_FOUND | translate"
                    [options]="GoalFilterOptions.Creators"
                    [ngModel]="
                        GoalFilter.creatorId == null
                            ? null
                            : GoalFilter.creatorId
                    "
                    (ngModelChange)="
                        GoalFilter.creatorId = $event === '' ? null : $event
                    "
                    forceDropdownPosition
                >
                </ng-select>
            </div>
            <div class="col p-1">
                <label class="mb-0">{{ i18n._127_STATUS | translate }}</label>
                <ng-select
                    [placeholder]="placeholderText"
                    [notFoundMsg]="i18n._7413_NO_RESULTS_FOUND | translate"
                    [options]="GoalFilterOptions.Statuses"
                    [ngModel]="
                        GoalFilter.statusId == null ? null : GoalFilter.statusId
                    "
                    (ngModelChange)="
                        GoalFilter.statusId = $event === '' ? null : $event
                    "
                    forceDropdownPosition
                >
                </ng-select>
            </div>
            <div class="col p-1">
                <label class="mb-0">{{
                    i18n._7332_DISPOSITION | translate
                }}</label>
                <ng-select
                    [placeholder]="placeholderText"
                    [notFoundMsg]="i18n._7413_NO_RESULTS_FOUND | translate"
                    [options]="GoalFilterOptions.Dispositions"
                    [ngModel]="
                        GoalFilter.dispositionId == null
                            ? null
                            : GoalFilter.dispositionId
                    "
                    (ngModelChange)="
                        GoalFilter.dispositionId = $event === '' ? null : $event
                    "
                    forceDropdownPosition
                >
                </ng-select>
            </div>
            <div class="col p-1 pt-3 history-filter-buttonset">
                <button
                    class="btn mr-2"
                    (click)="filter('GOALS')"
                >
                    {{ i18n._7362_APPLY | translate }}
                </button>
                <button
                    class="btn"
                    (click)="clearFilter('GOALS')"
                >
                    {{ i18n._7363_CLEAR | translate }}
                </button>
            </div>
        </div>
    </div>
</div>

<div class="tab-content">
    <div
        role="tabpanel"
        class="tab-pane active ng-star-inserted"
        aria-labelledby="tab-observations"
        id="tab-observations-panel"
        aria-expanded="true"
        *ngIf="activeHistoryTab == 'tab-observations'"
    >
        <div class="ng-tns-c5-11 ng-star-inserted">
            <cmps-observations-history
                [performerId]="performerId"
                [numRecords]="numRecords"
                [displayRecords]="displayRecords"
                [filterOptions]="ObservationFilterOptions"
                [filters]="oFilter"
                (displayedRecordsChange)="handleDisplayedRecords($event)"
                (totalRecordsChange)="handleTotalRecords($event)"
            >
            </cmps-observations-history>
        </div>
    </div>

    <div
        role="tabpanel"
        class="tab-pane active ng-star-inserted"
        aria-labelledby="tab-commitments"
        id="tab-commitments-panel"
        aria-expanded="true"
        *ngIf="activeHistoryTab == 'tab-commitments'"
    >
        <div class="ng-tns-c5-11 ng-star-inserted">
            <cmps-commitments-history
                [performerId]="performerId"
                [numRecords]="numRecords"
                [displayRecords]="displayRecords"
                [filterOptions]="CommitmentFilterOptions"
                [filters]="cFilter"
                (displayedRecordsChange)="handleDisplayedRecords($event)"
                (totalRecordsChange)="handleTotalRecords($event)"
            >
            </cmps-commitments-history>
        </div>
    </div>

    <div
        role="tabpanel"
        class="tab-pane active ng-star-inserted"
        aria-labelledby="tab-goals"
        id="tab-goals-panel"
        aria-expanded="true"
        *ngIf="activeHistoryTab == 'tab-goals'"
    >
        <div class="ng-tns-c5-11 ng-star-inserted">
            <cmps-goals-history
                [performerId]="performerId"
                [numRecords]="numRecords"
                [displayRecords]="displayRecords"
                [filterOptions]="GoalFilterOptions"
                [filters]="gFilter"
                (displayedRecordsChange)="handleDisplayedRecords($event)"
                (totalRecordsChange)="handleTotalRecords($event)"
            >
            </cmps-goals-history>
        </div>
    </div>
</div>
